import { Box } from '@mui/material';
import React, { useState } from 'react';

import PostalItemDetail from './components/PostalItemDetail';
import PostalItemList from './components/PostalItemList';
import QRCodeButton from './components/QRCodeButton';
import QRCodeContent from './components/QRCodeContent';

const PostalFrontDesk = () => {
  const [displayPostalId, setDisplayPostalId] = useState<string | null>(null);
  const [tab, setTab] = useState(0);
  const [openQRCode, setOpenQRCode] = useState(false);

  const isDisplayPostalItemDetail = displayPostalId !== null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        width: '100vw',
        height: '100vh',
        display: 'grid',
        gridTemplateRows: 'var(--header-height) 1fr',
        '*': {
          letterSpacing: '0.0864rem',
        },
      }}
    >
      <Box>
        <QRCodeButton open={openQRCode} setOpen={setOpenQRCode} />
      </Box>
      {!isDisplayPostalItemDetail && (
        <PostalItemList
          setDisplayPostalId={setDisplayPostalId}
          tab={tab}
          setTab={setTab}
        />
      )}
      {isDisplayPostalItemDetail && (
        <PostalItemDetail
          postalId={displayPostalId}
          onClose={() => setDisplayPostalId(null)}
        />
      )}
      {openQRCode && <QRCodeContent />}
    </Box>
  );
};

export default PostalFrontDesk;
